
import CloudFog from "../../../assets/duotone/CloudFog.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudFogIcon({ className, dataTestid = "CloudFogIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudFog data-testid={dataTestid} className={classes} {...rest} />
  );
}
